import api from '@/assets/plugins/axios'
import {backendUrl} from '@/assets/js/config'
import queryString from 'querystring'
let headers = {'Content-type': 'application/x-www-form-urlencoded'}
class LoginService {
  // 查询管理员账号
  getAdminAccount (params){
    return api.get(`${backendUrl}/user/company_info`, params).then(ret => {
      // console.log(ret);
      return ret
    })
  }
  // 员工账号/个人 登录 将废弃..........
  userLogin (params){
    return api.post(`${backendUrl}/user/login`, params, headers).then(ret => {
      // console.log(ret);
      return ret
    })
  }
  // 管理员账号 登录 将废弃..........
  adminLogin (params){
    return api.post(`${backendUrl}/user/admin_login`, params, headers).then(ret => {
      // console.log(ret);
      return ret
    })
  }
  // 2. R2 统一使用登录接口
  login (params) {
    return api.post(`${backendUrl}/user/auth_login`, params, headers).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  // 3. 获取空间列表
  getWorkSpaceList (params){
    return api.get(`${backendUrl}/workspace/list`, params).then(ret => {
      // console.log(ret);
      return ret
    })
  }
  // 4. 单点登录
  singleLogin (params){
    return api.get(`${backendUrl}/user/cas/account`, params).then(ret => {
      // console.log(ret);
      return ret
    })
  }
  // 5. 短息验证码
  getMobileCode (query, params) {
    return api.post(`${backendUrl}/sms/send?` + queryString.stringify(query), params, headers).then(ret => {
      return ret
    })
  }
  // 6. 根据手机号、短信验证码获取关联账号列表
  getMobileAccount (params) {
    return api.post(`${backendUrl}/user/mobile_relation_accounts`, params, headers).then(ret => {
      return ret
    })
  }
  // 7. 根据手机号一键注册
  mobileFastReg (params) {
    return api.post(`${backendUrl}/user/mobile_fast_reg`, params, headers).then(ret => {
      return ret
    })
  }
  // 8. 根据用户Id免密登录
  loginById (id, params) {
    return api.post(`${backendUrl}/user/${id}/login`, params, headers).then(ret => {
      return ret
    })
  }
  fetchVerifyCode (query, params, token){
    return api.post(`${backendUrl}/user/mobile/code?mobile=${query.mobile}&sign=${query.sign}&appId=${query.appId}&t=${query.t}`).then(ret => {
      return ret
    })
  }
  verifyCode (mobile, verifyCode){
    return api.post(`${backendUrl}/user/mobile/check?mobile=${mobile}&verifyCode=${verifyCode}`).then(ret => {
      return ret
    })
  }
  isDoubleVerify (mobile){
    return api.get(`${backendUrl}/user/mobile/checked?mobile=${mobile}`).then(ret => {
      return ret
    })
  }
  getEnabledStatus (){
    return api.get(`${backendUrl}/user/mobile/check/status`).then(ret => {
      return ret
    })
  }
  // checkEnabled (query){
  //   return api.post(`${backendUrl}/user/mobile/check/enabled?enabled=${query.enabled}`).then(ret => {
  //     return ret
  //   })
  // }
}
export default new LoginService()
